import { WrenchTheme } from '@wds/styles';
import { createUseStyles } from 'react-jss';
import { LogoColors } from './typings';

const useStyles = createUseStyles(
  ({ semanticColor, typeColor }: typeof WrenchTheme) => ({
    logo: (props: { color: LogoColors }) => ({
      color: props.color === 'alt' ? typeColor.light : semanticColor.primary,
      fill: props.color === 'alt' ? typeColor.light : semanticColor.primary,
    }),
  })
);

export default useStyles;
